import { render, staticRenderFns } from "./TheHeaderAppSwitcher.vue?vue&type=template&id=389006f4&scoped=true"
import script from "./TheHeaderAppSwitcher.vue?vue&type=script&lang=js"
export * from "./TheHeaderAppSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderAppSwitcher.vue?vue&type=style&index=0&id=389006f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389006f4",
  null
  
)

export default component.exports